/* eslint-disable no-magic-numbers */
import classnames from 'classnames';
import { find } from 'lodash';
import React, { useCallback, useMemo, useRef } from 'react';
import Icon from '../../../../common/components/utils/Icon';
import Ripple from '../../../../common/components/utils/Ripple';
import { Locked } from '../../../../model/PermissionTypes';
import { Inactive, isActive } from '../../../../model/Statuses';
import useT from '../Translations/useT';
import useHelpNoteTitleIfPresent from '../Translations/useHelpNoteTitleIfPresent';
import styles from './Module.scss';
const Module = ({ module, accessItems, dndIndex, onCLick, }) => {
    const t = useT();
    const helpNoteTitle = useHelpNoteTitleIfPresent(module.title);
    const status = useMemo(() => { var _a; return ((_a = find(accessItems, { moduleId: module.id })) === null || _a === void 0 ? void 0 : _a.status) || Inactive.value; }, [accessItems, module.id]);
    const isDragging = useRef(false);
    const startCoords = useRef({ x: 0, y: 0 });
    const handleModuleClick = useCallback((e) => {
        e.preventDefault();
        if (isDragging.current) {
            return;
        }
        onCLick(module);
    }, [onCLick, module]);
    const iconBackground = useMemo(() => (module.group === 'zone' ? 'bg-orange' : 'bg-success'), [module.group]);
    const locked = useMemo(() => !!module.type && module.type === Locked.value, [module.type]);
    const disabled = useMemo(() => !isActive({ status }) && !locked, [
        status,
        locked,
    ]);
    const handleMouseDown = e => {
        startCoords.current = { x: e.clientX, y: e.clientY };
    };
    const handleMouseUp = e => {
        const endCoords = { x: e.clientX, y: e.clientY };
        // Check if the mouse moved significantly (threshold can be adjusted)
        const deltaX = Math.abs(endCoords.x - startCoords.current.x);
        const deltaY = Math.abs(endCoords.y - startCoords.current.y);
        if (deltaX > 5 && deltaY > 5) {
            isDragging.current = true;
            setTimeout(() => {
                isDragging.current = false;
            }, 100);
        }
    };
    return (<div className="text-center">
      <Ripple>
        <a className={classnames(iconBackground, 'btn btn-rounded btn-icon btn-float overflow-visible', { [styles.disabled]: disabled })} onClick={locked ? undefined : handleModuleClick} onMouseDown={handleMouseDown} onMouseUp={handleMouseUp}>
          {module.icon ? (<Icon name={module.icon} type={module.iconType}/>) : null}
          {locked ? <Icon className={styles.locked} name="lock2"/> : null}
        </a>
      </Ripple>
      <div className="text-grey-300 mt-5">
        <a title={helpNoteTitle} onClick={locked ? undefined : handleModuleClick} onMouseDown={handleMouseDown} onMouseUp={handleMouseUp}>
          {t(module.title)}
        </a>
      </div>
    </div>);
};
export default Module;
